import { Observable, of } from 'rxjs';
import { Condition } from '../model/rule-engine.model';

/**
 * Decorator function to ensure we return a condition that when assert is called to return an Observable<boolean>
 * @param condition
 * @returns
 */
export function AsyncConditionDecorator<T>(condition: Condition<T>): { assert(fact: T): Observable<boolean> } {
  return {
    ...condition,
    assert: (fact): Observable<boolean> => {
      const conditionAssertion = condition.assert(fact);
      return typeof conditionAssertion === 'boolean' ? of(conditionAssertion) : conditionAssertion;
    },
  };
}
